import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ModalComponent } from "@app/shared/components";
import { Plant } from '@models/plant.model';

@Component({
    selector: 'app-lift-create-modal',
    templateUrl: './lift-create-modal.component.html',
    styleUrls: ['./lift-create-modal.component.scss']
})
export class LiftCreateModalComponent implements OnInit {
    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() plants: Plant[];
    @Input() userIdentity: string;

    @Output() create = new EventEmitter<any>();

    liftForm: UntypedFormGroup;

    showValidations = false;

    constructor(private formBuilder: UntypedFormBuilder) {
    }

    ngOnInit() {
        this.liftForm = this.formBuilder.group({
            'name': ['', Validators.required],
            'plant': [null, Validators.required]
        });
    }

    open() {
        this.reset();
        this.modal.open();
    }

    reset() {
        this.liftForm.reset();
    }

    close() {
        this.modal.close();
    }

    onConfirm() {
        if (!this.liftForm.valid) {
            this.showValidations = true;
            return;
        }
        this.showValidations = false;

        const formData = Object.assign(
            {},
            this.liftForm.value
        );
        this.create.emit(formData);
    }

}
